
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
            Linha Barcode<span className="trademark">®</span>
          </h2>
          <p className="text-xl font-gilroy text-crop-dark max-w-3xl mx-auto">
            Três níveis de profundidade para atender diferentes necessidades de identificação molecular
          </p>
        </div>

        <div className="overflow-x-auto mb-12">
          <table className="w-full bg-crop-white rounded-2xl shadow-lg overflow-hidden">
            <thead className="bg-crop-teal/10">
              <tr>
                <th className="px-6 py-4 text-left font-gilroy font-bold text-crop-black">Serviço</th>
                <th className="px-6 py-4 text-left font-gilroy font-bold text-crop-black">Descrição</th>
                <th className="px-6 py-4 text-left font-gilroy font-bold text-crop-black">Nível de Resolução</th>
                <th className="px-6 py-4 text-left font-gilroy font-bold text-crop-black">Aplicações Principais</th>
                <th className="px-6 py-4 text-left font-gilroy font-bold text-crop-black">Benefícios</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-crop-teal/10 hover:bg-gray-50/50 transition-colors">
                <td className="px-6 py-6 font-gilroy font-semibold text-crop-black">Barcode<span className="trademark">®</span></td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Identificação molecular baseada em um marcador genético de referência ("código de barras" genético).</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Para quem busca identificação até gênero</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Triagem inicial de contaminantes, monitoramento de rotina, verificação rápida de isolados.</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Método rápido, confiável, custo acessível e alinhado a guias regulatórios</td>
              </tr>
              <tr className="border-t border-crop-teal/10 hover:bg-gray-50/50 transition-colors">
                <td className="px-6 py-6 font-gilroy font-semibold text-crop-black">Barcode<span className="trademark">®</span> Pro</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Identificação avançada por análise multilocus (MLST), com maior poder discriminatório entre organismos próximos.</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Para quem busca identificação em nível de espécie</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Controle de qualidade em processos industriais, auditorias regulatórias, certificação de insumos biológicos, diferenciação de espécies similares.</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Alta resolução, robustez científica, aplicabilidade regulatória e suporte em registros oficiais.</td>
              </tr>
              <tr className="border-t border-crop-teal/10 hover:bg-gray-50/50 transition-colors">
                <td className="px-6 py-6 font-gilroy font-semibold text-crop-black">Barcode<span className="trademark">®</span> Meta</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Perfil metagenômico de comunidades microbianas, sem necessidade de cultivo, utilizando sequenciamento de nova geração.</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Microbiota completa (bactérias e fungos em nível de gênero/espécie predominante).</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Estudos ambientais, alimentos, cosméticos, probióticos, caracterização de microbioma humano e animal, detecção de contaminantes.</td>
                <td className="px-6 py-6 font-gilroy text-crop-dark">Visão global da ecologia microbiana, identificação de microrganismos não cultiváveis e análise de diversidade e abundância relativa.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <Card hover className="animate-fade-in">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-barcode-line text-3xl text-crop-black"></i>
              </div>
              <h3 className="text-2xl font-gilroy font-bold text-crop-black mb-4">Barcode<span className="trademark">®</span></h3>
              <p className="font-gilroy text-crop-dark mb-6 leading-relaxed">
                Identificação padrão baseada em código de barras genético. Método rápido e acessível para triagem de rotina e controle de contaminantes.
              </p>
              <a href="#contato">
                <Button variant="outline" size="sm" className="whitespace-nowrap">Saiba Mais</Button>
              </a>
            </div>
          </Card>

          <Card hover className="animate-fade-in">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-dna-line text-3xl text-crop-black"></i>
              </div>
              <h3 className="text-2xl font-gilroy font-bold text-crop-black mb-4">Barcode<span className="trademark">®</span> Pro</h3>
              <p className="font-gilroy text-crop-dark mb-6 leading-relaxed">
                Identificação avançada via MLST combinando múltiplos fragmentos genéticos. Ideal para auditorias e certificações.
              </p>
              <a href="#contato">
                <Button variant="outline" size="sm" className="whitespace-nowrap">Saiba Mais</Button>
              </a>
            </div>
          </Card>

          <Card hover className="animate-fade-in">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-stack-line text-3xl text-crop-black"></i>
              </div>
              <h3 className="text-2xl font-gilroy font-bold text-crop-black mb-4">Barcode<span className="trademark">®</span> Meta</h3>
              <p className="font-gilroy text-crop-dark mb-6 leading-relaxed">
                Análise metagenômica por NGS revelando comunidades microbianas completas. Identifica organismos não cultiváveis.
              </p>
              <a href="#contato">
                <Button variant="outline" size="sm" className="whitespace-nowrap">Saiba Mais</Button>
              </a>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
